import * as yup from "yup";

export const addUserFormValidationSchema = yup.object().shape({
  role: yup.string().required("Please select a role to continue!"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required(),
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("Email is required"),
  phone: yup.string().required("Phone number is required"),
  lastName: yup
    .string()
    .min(3, "Last Name must be at least 3 characters")
    .required("Last Name is required"),
  firstName: yup
    .string()
    .min(3, "First Name must be at least 3 characters")
    .required("First Name is required"),
});

export const createMainCategoryPageValidation = yup.object().shape({
  show: yup.boolean().required("Please Select Are You Show Category"),
  seoKeyword: yup
    .array()
    .of(yup.string())
    .required("SEO keywords are required"),
  metaKeyword: yup
    .array()
    .of(yup.string())
    .required("Meta keywords are required"),
  metaDescription: yup.string().required("Meta description is required"),
  metaTag: yup.array().of(yup.string()).required("Meta tags are required"),
  description: yup
    .string()
    .required("Description is required")
    .min(6, "Description must be at least 6 characters"),
  image: yup.string().required("Image is required"),
  slug: yup.string().required("Slug is required"),
  displayName: yup
    .string()
    .required("Display name is required")
    .min(3, "Display name must be at least 3 characters"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
});

export const createChildSubCategoryPageValidation = yup.object().shape({
  show: yup.boolean().required("Please Select Are You Show Category"),
  banner: yup.string().required("Banner image is required"),
  seoKeyword: yup
    .array()
    .of(yup.string())
    .required("SEO keywords are required"),
  metaKeyword: yup
    .array()
    .of(yup.string())
    .required("Meta keywords are required"),
  metaDescription: yup
    .string()
    .required("Meta description is required")
    .min(3, "Meta Description must be at least 3 characters"),
  metaTag: yup.array().of(yup.string()).required("Meta tags are required"),
  description: yup
    .string()
    .required("Description is required")
    .min(6, "Description must be at least 6 characters"),
  slug: yup.string().required("Slug is required"),
  image: yup.string().required("Image is required"),
  childSubCategoriesId: yup
    .string()
    .required("childSubCategories id is required"),
  displayName: yup
    .string()
    .required("Display name is required")
    .min(3, "Display name must be at least 3 characters"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
});

export const createChildCategoryPageValidation = yup.object().shape({
  show: yup.boolean().required("Please Select Are You Show Category"),
  seoKeyword: yup
    .array()
    .of(yup.string())
    .required("SEO keywords are required"),
  metaKeyword: yup
    .array()
    .of(yup.string())
    .required("Meta keywords are required"),
  metaDescription: yup
    .string()
    .required("Meta description is required")
    .min(3, "Meta Description must be at least 3 characters"),
  metaTag: yup.array().of(yup.string()).required("Meta tags are required"),
  description: yup
    .string()
    .required("Description is required")
    .min(6, "Description must be at least 6 characters"),
  slug: yup.string().required("Slug is required"),
  image: yup.string().required("Image is required"),
  mainCategoryId: yup.string().required("mainCategoryId id is required"),
  displayName: yup
    .string()
    .required("Display name is required")
    .min(3, "Display name must be at least 3 characters"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
});
